import M from "./ghl-ui.es1644.js";
import T from "./ghl-ui.es1645.js";
var c = 36e5, m = 6e4, i = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function x(e, r, n) {
  var a, u;
  if (!e || (a = i.timezoneZ.exec(e), a))
    return 0;
  var t;
  if (a = i.timezoneHH.exec(e), a)
    return t = parseInt(a[1], 10), l(t) ? -(t * c) : NaN;
  if (a = i.timezoneHHMM.exec(e), a) {
    t = parseInt(a[1], 10);
    var o = parseInt(a[2], 10);
    return l(t, o) ? (u = Math.abs(t) * c + o * m, t > 0 ? -u : u) : NaN;
  }
  if (p(e)) {
    r = new Date(r || Date.now());
    var I = n ? r : D(r), f = v(I, e), N = n ? f : H(r, f, e);
    return -N;
  }
  return NaN;
}
function D(e) {
  return T(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  );
}
function v(e, r) {
  var n = M(e, r), a = T(
    n[0],
    n[1] - 1,
    n[2],
    n[3] % 24,
    n[4],
    n[5],
    0
  ).getTime(), u = e.getTime(), t = u % 1e3;
  return u -= t >= 0 ? t : 1e3 + t, a - u;
}
function H(e, r, n) {
  var a = e.getTime(), u = a - r, t = v(new Date(u), n);
  if (r === t)
    return r;
  u -= t - r;
  var o = v(new Date(u), n);
  return t === o ? t : Math.max(t, o);
}
function l(e, r) {
  return -23 <= e && e <= 23 && (r == null || 0 <= r && r <= 59);
}
var s = {};
function p(e) {
  if (s[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), s[e] = !0, !0;
  } catch {
    return !1;
  }
}
export {
  x as default
};
